/*
* @author  Agence Dn'D <contact@dnd.fr>
* @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link    https://www.dnd.fr/
*/

(() => {
    const mobileBreakpoint = '(max-width: 767.98px)';
    const drawerSelector = '.js-cart-drawer';
    const stepTriggerSelector = '[data-step-toggle]';

    const fieldSelector = '[data-cart-attribute]';

    const questionSelector = '[data-sample-question]';
    const statusIconSelector = '[data-sample-status-icon]';

    const isQuestionAnswered = (questionEl) => !!questionEl.querySelector('input[type="radio"]:checked');

    const isMobile = () => window.matchMedia(mobileBreakpoint).matches;

    const updateBadge = (trigger) => {
        const badge = trigger.querySelector('[data-step-badge]');
        if (!badge) return;

        badge.classList.toggle('step-badge--active', trigger.getAttribute('aria-expanded') === 'true');
    };

    document.addEventListener('click', (event) => {
        if (!isMobile()) return;

        const trigger = event.target.closest(stepTriggerSelector);
        if (!trigger) return;

        const drawer = trigger.closest(drawerSelector);
        if (!drawer) return;

        requestAnimationFrame(() => {
            const isNowOpen = trigger.getAttribute('aria-expanded') === 'true';

            if (isNowOpen) {
                drawer.querySelectorAll(stepTriggerSelector).forEach((otherTrigger) => {
                    if (otherTrigger !== trigger && otherTrigger.getAttribute('aria-expanded') === 'true') {
                        otherTrigger.click();
                    }
                });
            }

            drawer.querySelectorAll(stepTriggerSelector).forEach(updateBadge);
        });
    });

    const ensureCartStep2Structure = () => {
        const content = document.getElementById('CartStep2Content');
        if (!content) return;

        const hasSampleForm = !!document.querySelector('.has-sample-form');
        const alreadyWired = content.classList.contains('toggle-target');

        if (hasSampleForm && !alreadyWired) {
            content.classList.add('toggle-target', 'toggle-target--hidden');
            content.firstElementChild?.classList.add('toggle-target-container');
        } else if (!hasSampleForm && alreadyWired) {
            content.classList.remove('toggle-target', 'toggle-target--hidden');
            content.firstElementChild?.classList.remove('toggle-target-container');
        }
    };

    const forceOpenOnDesktop = () => {
        if (isMobile()) return;

        document.querySelectorAll(stepTriggerSelector).forEach((trigger) => {
            const content = document.querySelector(trigger.dataset.toggleTarget);
            if (content && content.classList.contains('toggle-target--hidden')) {
                trigger.click();
            }
            updateBadge(trigger);
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            ensureCartStep2Structure();
            forceOpenOnDesktop();
        });
    } else {
        ensureCartStep2Structure();
        forceOpenOnDesktop();
    }

    document.addEventListener('on:cart:after-merge', () => {
        ensureCartStep2Structure();
        forceOpenOnDesktop();
    });

    window.addEventListener('on:breakpoint-change', forceOpenOnDesktop);

    document.addEventListener('change', async (event) => {
        const input = event.target.closest(fieldSelector);
        if (!input) return;

        const attributeKey = input.dataset.cartAttribute;

        try {
            const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    attributes: { [attributeKey]: input.value }
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            document.dispatchEvent(
                new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
            );
        } catch (error) {
            console.warn(error);
        }
    });

    const updateStatusIcon = (questionEl) => {
        const icon = questionEl.querySelector(statusIconSelector);
        if (icon) {
            icon.classList.toggle('sample-form__status-icon--answered', isQuestionAnswered(questionEl));
        }
    };

    const updateFormState = () => {
        const questions = document.querySelectorAll(questionSelector);
        if (questions.length === 0) return;

        let allAnswered = true;

        questions.forEach((questionEl) => {
            updateStatusIcon(questionEl);
            if (!isQuestionAnswered(questionEl)) {
                allAnswered = false;
            }
        });

        document.querySelectorAll('[data-sample-checkout-btn]').forEach((btn) => {
            btn.setAttribute('aria-disabled', String(!allAnswered));
        });

        document.querySelectorAll('[data-sample-notice]').forEach((notice) => {
            notice.hidden = allAnswered;
        });
    };

    document.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-sample-checkout-btn]');
        if (btn && btn.getAttribute('aria-disabled') === 'true') {
            event.preventDefault();
        }
    });

    document.addEventListener('change', (event) => {
        if (event.target.closest(questionSelector)) {
            updateFormState();
        }
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateFormState);
    } else {
        updateFormState();
    }

    document.addEventListener('on:cart:after-merge', updateFormState);

    let sampleAttributesCleared = false;

    const clearSampleAttributesIfCartEmpty = async () => {
        const content = document.querySelector('.cart-drawer__content');
        const isEmpty = content?.classList.contains('cart-drawer__content--hidden');

        if (!isEmpty) {
            sampleAttributesCleared = false;
            return;
        }

        if (sampleAttributesCleared) return;
        sampleAttributesCleared = true;

        try {
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    attributes: {
                        sample_application_domain: '',
                        sample_surface_area: ''
                    }
                })
            });
        } catch (error) {
            console.warn(error);
        }
    };

    document.addEventListener('on:cart:after-merge', clearSampleAttributesIfCartEmpty);
})();